<template>
  <div>
    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="SAMPLE ORDER CREATE">
          <template slot="actions">

            <vs-button icon-pack="feather" icon="icon-arrow-left" @click="refreshData" class="mr-4" color="primary"
              type="border">
              Back to sample orders
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">

            <vs-table id="sample_list" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort"
              :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="header">

                <vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="filters['search']"
                  class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
                <vs-button id="place_order" :disabled="cartItems.length === 0" icon-pack="feather"
                  icon="icon-shopping-cart" @click="onClickPlaceOrder" class="mr-12" color="primary" type="filled">
                  Place order ({{ cartItems.length }} Items)
                </vs-button>
              </template>

              <template slot="thead">
                <vs-th width="30%">PRODUCT CODE</vs-th>
                <vs-th width="20%">PRODUCT NAME</vs-th>
                <vs-th width="20%">QUANTITY (GRAMS)</vs-th>
                <vs-th width="30%" class="">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td>
                    <vs-input type="text" v-model="data[indextr].quantity" class="w-full" :name="indextr + 'quantity'" />
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="" text="Add to cart" position="left">
                        <vs-button :disabled="Number(tr.quantity) < 0 || !tr.quantity" :id="'add_button' + '' + indextr"
                          v-if="!checkSampleInCart(data[indextr])"
                          @click.native="onClickAddToCart(data[indextr].id, data[indextr].quantity, indextr)" size="small" color="primary"
                          type="border" icon-pack="feather" icon="icon-plus">Add</vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="mr-2" text="Update quantity" position="top">
                        <vs-button :id="'update_button'+''+ indextr" v-if="checkSampleInCart(data[indextr])"
                                   @click.stop="onClickUpdateCart(data[indextr].id, data[indextr].quantity, indextr)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-save"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="" text="Remove from  cart" position="left">
                        <vs-button :id="'remove_button' + '' + indextr" v-if="checkSampleInCart(data[indextr])"
                          @click.native="onClickRemoveFromCart(data[indextr].id, indextr)" size="small" color="danger"
                          type="border" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                      </vx-tooltip>

                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-sample-order-pop-up ref="createCustomerSampleOrderPopUp" />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import CreateCustomerSampleOrderPopUp from '@/components/popups/customer/sample-orders/CreateCustomerSampleOrderPopUp'

const CustomerRepository = RepositoryFactory.get('customer')

export default {
  name: 'AllUsersList',
  data() {
    return {
      staff: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      customerId: '',
      cartItems: []
    }
  },
  components: {
    'v-select': vSelect,
    CreateCustomerSampleOrderPopUp
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  async mounted() {
    this.customerId = this.$route.params.id
  },
  methods: {
    async refreshData() {
      await this.loadStaff()
      this.$emit('back')
    },
    async onlyRefreshData() {
      await this.loadStaff()
    },
    async loadStaff() {
      try {
        await this.$vs.loading({
          container: '#sample_list',
          scale: 0.45
        })
        await this.getItemsInItemsCart()
        const { data } = await CustomerRepository.getSampleList(this.page, this.filterQuery, 20, this.sort)
        this.staff = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#sample_list > .con-vs-loading')
    },

    async onClickAddToCart(id, quantity, indextr) {
      await this.$vs.loading({
        container: `#add_button${indextr}`,
        scale: 0.45
      })
      try {
        const cartPayload = { formulation_id: id,quantity: quantity }
        await CustomerRepository.addFormulationsToCart(cartPayload)
        await this.getItemsInItemsCart()
        this.showSuccessMessage(' Added to the Cart')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close(`#add_button${indextr} > .con-vs-loading`)
    },
    async onClickRemoveFromCart(id, indextr) {
      await this.$vs.loading({
        container: `#remove_button${indextr}`,
        scale: 0.45
      })
      try {
        const search = this.cartItems.find((n) => n.formulation_id === id)
        await CustomerRepository.removeFormulationsFromCart(search.id)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Removed from cart')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close(`#remove_button${indextr} > .con-vs-loading`)
    },
    
    async onClickUpdateCart(id, quantity, indextr) {
        await this.$vs.loading({
          container: `#update_button${indextr}`,
          scale: 0.45
        })
        try {
          const search = this.cartItems.find((n) => n.formulation_id === id )
          await CustomerRepository.updateFormulationSampleCart(search.id, { quantity: quantity })
          await this.getItemsInItemsCart()
          this.showSuccessMessage('Cart updated')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#update_button${indextr} > .con-vs-loading`)
    },

    async getItemsInItemsCart() {
      await this.$vs.loading({
        container: '#place_order',
        scale: 0.45
      })
      try {
        const { data } = (await CustomerRepository.getItemsInItemsCart()).data
        this.cartItems = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#place_order > .con-vs-loading')
    },
    async onClickPlaceOrder() {
      await this.$refs.createCustomerSampleOrderPopUp.openPopup(this.customerId)
    },

    filterQueryUpdate() {
      this.loadStaff()
    },

    handleChangePage(page) {
      this.page = page;
      this.loadStaff()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.loadStaff()
      }
    },
    projectBriefColorFactory(id) {
      switch (id) {
        case 1:
          return 'warning';
        case 2:
          return 'primary';
        case 3:
          return '#f05945';
        case 4:
          return '#f58634';
        case 5:
          return '#206a5d';
      }
    },
    onClickFormula(id) {
      this.$router.push({ path: `/pages/formulations/${id}` })
    },
    onClickStatusChangeConfirm(id, status) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm',
        text: 'Are you sure you want to make this change?',
        accept: this.onChangeSampleOrderStatus,
        parameters: [id, status]
      })
    },
    async onChangeSampleOrderStatus(params) {
      this.$vs.loading()
      try {
        await CustomerRepository.statusChangeCustomerSampleOrders(params[0], params[1])
        this.showSuccessMessage('Status change successfully!')
        await this.loadStaff()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    checkSampleInCart: function (object) {
      const arr = this.cartItems.filter((n) => n.formulation_id === object.id)
      return arr.length > 0
    }

  },
  watch: {
    page() {
      this.loadStaff()
    }
  },
  computed: {

  }
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}

table td {
  vertical-align: top;
  min-width: 140px;
  padding-bottom: .8rem;
  word-break: break-all;
}</style>
